import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "py-2" }
const _hoisted_2 = { class: "flex justify-between" }
const _hoisted_3 = ["value"]
const _hoisted_4 = { class: "py-2" }
const _hoisted_5 = { class: "py-2" }
const _hoisted_6 = ["value"]
const _hoisted_7 = { class: "py-2" }
const _hoisted_8 = { class: "py-2" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("textarea", {
  class: "w-full h-20 rounded-md",
  name: "remark"
}, null, -1)

import { useStore } from 'vuex';
import ToolsUpload from '../../tools/Upload.vue'
import ExampleTicketToolTip from './tooltip/ExampleTicketTooltip.vue'
import ToolsInputMobile from '../../tools/InputMobile.vue'
import { getAmountType } from '@/utils/ticket-config'
import InputDecimal from '../../tools/InputDecimal.vue'
import { onMounted, ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'UpdateValidBalance',
  props: {
  username: String,
},
  setup(__props) {

const store = useStore()


const typeList = ref([
  {
    value: 0,
    name: "-- Select Type --",
  },
]);

const type = ref({
  name: typeList.value[0].name,
  value: 0,
});

const getExampleImage = () => {
  const baseUrl = window.location.origin
  return `${baseUrl}/ticket-example/รูปตัวอย่าง ขอปรับเพิ่มหรือลด Valid Balance.png`
}

const getType = () => {
 
 typeList.value = getAmountType().map((item: any) => ({
      name: item.label,
      value: item.value
    }))
};

onMounted(() => {
  getType();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createTextVNode(_toDisplayString(_ctx.$t('messages.ticketManagement.formList.field.operatorName')) + " ", 1),
        _createVNode(ExampleTicketToolTip, {
          image: getExampleImage()
        }, null, 8, ["image"])
      ]),
      _createElementVNode("input", {
        value: _unref(store).state.selectedOperator.name,
        name: "operator_name",
        type: "text",
        class: "w-full rounded-md",
        disabled: true
      }, null, 8, _hoisted_3)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createTextVNode(_toDisplayString(_ctx.$t('messages.ticketManagement.formList.field.customerUsername')) + " ", 1),
      _createVNode(ToolsInputMobile, { name: "username" })
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createTextVNode(_toDisplayString(_ctx.$t('messages.ticketManagement.formList.field.amountType')) + " ", 1),
      _withDirectives(_createElementVNode("select", {
        id: "type",
        name: "type",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((type.value.name) = $event)),
        class: "capitalize mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm rounded-md"
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(typeList.value, (row) => {
          return (_openBlock(), _createElementBlock("option", {
            key: row.name,
            value: row.name
          }, _toDisplayString(row.name), 9, _hoisted_6))
        }), 128))
      ], 512), [
        [_vModelSelect, type.value.name]
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createTextVNode(_toDisplayString(_ctx.$t('messages.ticketManagement.formList.field.amountAdjust')) + " ", 1),
      _createVNode(InputDecimal, { name: "amount" })
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createTextVNode(_toDisplayString(_ctx.$t('messages.ticketManagement.formList.field.remark')) + " ", 1),
      _hoisted_9
    ]),
    _createVNode(ToolsUpload)
  ], 64))
}
}

})